import {
  EditContextProvider,
  Form,
  SaveButton,
  useEditController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import {
  Button as MUIButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Resources } from '../../resource';
import LinkConfigForm from './LinkConfigForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const EditLinkConfig = ({
  id,
  onClose,
}: {
  id: string | number;
  onClose: () => void;
}) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useEditController({
    id,
    resource: Resources.linkConfig,
    mutationMode: 'pessimistic',
    mutationOptions: {
      onSuccess: () => {
        notify(t('module.linkConfig.updateSuccess'), { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        const errorCode = error?.body?.code || error?.code;
        if (errorCode === 'LINK_CONFIG_CONFLICT') {
          notify(t('module.linkConfig.validate.conflict'), { type: 'error' });
        } else {
          notify(t('module.linkConfig.unknownErrorUpdate'), { type: 'error' });
        }
      },
    },
  });

  if (controller.isLoading || !controller.record) return null;

  return (
    <EditContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>{t('module.linkConfig.edit')}</DialogTitle>
        <DialogContent>
          <LinkConfigForm isCreate={false} />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="link-configs" action="update">
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </EditContextProvider>
  );
};

export default EditLinkConfig;
